"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[2089],{

/***/ 2089:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ stickyPageNav)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * * Sticky-page-nav is used for two main purposes:
 * * 1.) Detecting when the sticky-nav has changed states from 'stuck' to 'unstuck' (or vice-versa)
 * * 2.) Detecting when a pageScrollTargets has been scrolled into/out-of focus
 *
 * @options
 * [data-utility="sticky-page-nav"] {required} - Utility trigger-element
 * 
 */

function stickyPageNav({ wrapper }) {

  const settings = {
    desktopNavbar: '[data-primary-nav="desktop"]',
    mobileNavbar: '[data-primary-nav="mobile"]',
    pageScrollTrigger: '[data-page-scroll-trigger]',
  }

  const $cache = {
    $stickyPageNav: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $pageScrollTriggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.pageScrollTrigger),

    $desktopGlobalNav: jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.desktopNavbar),
    $mobileGlobalNav: jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.mobileNavbar),
  }

  const config = {
    activatedClass: 'tw-activated',

    stickyPageNavObserver: null,
    stickyPageNavRootOffset: 0,
    
    scrollingPageNavObserver: null,
    pageScrollTargetsMap: new Map()
  };
  

  ;(function init() {
    // * Listen for when this sticky-page-nav is 'stuck' to the top of the page
    // * Use this as feedback to enable stuck / unstuck states
    initStickyPageNav()


    // * Listen for when a pageScrollTarget associated with the sticky-page-nav enters the viewport
    // * Use this as feedback to activate/deactivate Navbar Link 'highlight'
    initScrollingPageNav()
  })()


  function initStickyPageNav() {
    setCurrentGlobalNavHeight(); // Set Global Nav Height
    observeStickyPageNav(); // Use Global Nav Height to observe stick/unstick
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', handleWindowResize); // Refresh Observer on-resize in case Navbar changed between Mobile/Desktop
  }


  function initScrollingPageNav() {
    identifyValidPageScrollTargets();
    if (config.pageScrollTargetsMap.size === 0) return; // no valid pageScrollTargets found in map
    observePageScrollTargets();
  }


  function observeStickyPageNav() {
    // * Listen for when this Navbar becomes stuck/unstuck
    // * if any of the Sticky Navbar enters the -rootMargin, trigger Intersection
    if (!!config.stickyPageNavObserver) return // if there is an active Observer stored, garbage-collect before refreshing

    const stickyPageNavObserverOptions = {
      root: null,
      rootMargin: `-${config.stickyPageNavRootOffset}px 0px 0px 0px`, // negative top-margin extends the top trigger-boundary DOWN
      threshold: [1] // Threshold of 1 means ANY part (even 1 pixel) of element visible/invisible will trigger intersection
    };

    let observer = new IntersectionObserver(handleStickyChange, stickyPageNavObserverOptions); // Instantiate Observer w/ callback + options
    config.stickyPageNavObserver = observer; // Store Observer reference in config
    config.stickyPageNavObserver.observe(wrapper); // Initialize Observer
  }


  function handleStickyChange(entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) { // Not intersecting == 'STUCK'
        entry.target.classList.add(config.activatedClass)
      } else { // Floating within viewport == 'UNSTUCK'
        entry.target.classList.remove(config.activatedClass)
      }
    })
  }


  function setCurrentGlobalNavHeight() {
    // Use currently-visible Mobile/Desktop Nav to measure 'active' Global Nav Height
    if (!!$cache.$mobileGlobalNav.is(':visible')) {
      config.stickyPageNavRootOffset = $cache.$mobileGlobalNav.outerHeight() + 1;
    } else {
      config.stickyPageNavRootOffset = $cache.$desktopGlobalNav.outerHeight() + 1;
    }
  }


  function resetStickyPageNavObserver() {
    config.stickyPageNavObserver.disconnect(); // disconnect stickyPageNavObserver
    config.stickyPageNavObserver = null; // Clear stored Observer reference
    setCurrentGlobalNavHeight(); // Set Global Nav Height (in case it changed with the resize)
    observeStickyPageNav(); // Create + store a new Observer using updated Global Nav Height
  }


  function handleWindowResize() {
    resetStickyPageNavObserver();
  }


  function identifyValidPageScrollTargets() {
    // * For each trigger / selector provided, validate that the target element exists
    if ($cache.$pageScrollTriggers.length === 0) return

    $cache.$pageScrollTriggers.each((index, node)=>{
      let triggerSelectorVal = node.dataset.pageScrollTrigger;
      let pageScrollTargetNode = document.querySelector(triggerSelectorVal);
      
      // If node exists, add node + config obj as key/value set in pageScrollTargets map + event listener for enter/exit
      if (!!pageScrollTargetNode) {
        config.pageScrollTargetsMap.set(pageScrollTargetNode, {
          triggerNodeSelector: `[data-page-scroll-trigger='${triggerSelectorVal}']`,
          targetNodeSelector: triggerSelectorVal,
          targetNode: pageScrollTargetNode
        })

        pageScrollTargetNode.addEventListener('scroll-target-enter', (e) => handleScrollTarget(e, 'enter'))
        pageScrollTargetNode.addEventListener('scroll-target-exit', (e) => handleScrollTarget(e, 'exit'))
      }
    })
  }


  function observePageScrollTargets() {
    // * Watch for when a pageScrollTarget enters/exits the viewport
    // * If sticky-page-navigation contains a Same-Page Link corresponding to this pageScrollTarget, highlight the corresponding Link in the Navbar while this pageScrollTarget is in-view
    if (!!config.scrollingPageNavObserver) return // if there is an active Observer stored, garbage-collect before refreshing
    
    const scrollingPageNavObserverOptions = {
      root: null,
      rootMargin: `0px 0px 0px 0px`,
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] // 'observe' every 10% of the viewport traversed
    };

    config.scrollingPageNavObserver = new IntersectionObserver(handleScrollingChange, scrollingPageNavObserverOptions); // Store Observer reference in config, in case we want to disconnect
    
    config.pageScrollTargetsMap.forEach((targetObj) => {
      config.scrollingPageNavObserver.observe(targetObj.targetNode); // Initialize Observer for each pageScrollTarget
    })
  }


  function handleScrollingChange(entries, observer) {
    entries.forEach(entry => {
      let scrollTargetNode = entry.target;

      if (entry.isIntersecting) { // Scroll target is (at least partially) visible in the viewport

        // As long as a section is taking up at least 45% of the visible screen, it will get spotlighted
        let screenRealEstateRatio = entry.intersectionRect.height / entry.rootBounds.height;
        if (screenRealEstateRatio > 0.45) {
          scrollTargetNode.dispatchEvent(new CustomEvent('scroll-target-enter', { detail: { scrollTargetNode } }))
        } else {
          scrollTargetNode.dispatchEvent(new CustomEvent('scroll-target-exit', { detail: { scrollTargetNode } }))
        }

      } else {
        scrollTargetNode.dispatchEvent(new CustomEvent('scroll-target-exit', { detail: { scrollTargetNode } }))
      }
    })
  }


  function handleScrollTarget(e, scrollBehavior) {
    let retrievedObj = config.pageScrollTargetsMap.get(e.detail.scrollTargetNode);
    if (!retrievedObj) return;

    let $triggerWrapperNode = jquery__WEBPACK_IMPORTED_MODULE_0___default()(retrievedObj.triggerNodeSelector);
    if ($triggerWrapperNode.length === 0) return;

    switch (scrollBehavior) {
      case 'enter':
        $triggerWrapperNode.addClass(config.activatedClass);
        $triggerWrapperNode[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); // ensures that the selected Link is always visible, even if overflowing (ie, on Mobile, or lots of links in Navbar)
        break;

      case 'exit':
        $triggerWrapperNode.removeClass(config.activatedClass)
        break;
    

      default:
        break;
    }
  }
}

/***/ })

}]);